export default __webpack_public_path__ + "static/media/Group@3x.769a217e.png";